__turbopack_context__.v({
  "anchor": "KAYJcW_anchor",
  "icon": "KAYJcW_icon",
  "placeholder": "KAYJcW_placeholder",
  "wrapper": "KAYJcW_wrapper",
});
